module.exports = __webpack_public_path__ + "img/icon_map_3_5_yj.0c83418f.png";